import React from 'react'
import "./WhatMakesUsDifferent.css"
export default function WhatMakesUsDifferent() {
  return (
    <>
    <div className="WhatMakesUsDifferent">
    </div>
        <div className="heading1">
            What makes us different?
        </div>
        <div className="heading2">
            Reimagining and rewiring self-care
        </div>
        <div className="content1">
        You care about conscious consumption, and so do we. 
        <br/><br/>
        When it comes to your health, “good enough” is not good enough. We're here to flip the script on that narrative because you deserve the best 
        <br/><br/>
        We collaborate with researchers and doctors to 
        <br/><br/>
        <ul className='Bullets'  style={{ listStyleType: "disc" }} >
        <li >Help you get granular about your health and self-care with personalized insights, and</li>
        <br/>

        <li >Equip you with simple, sustainable products that get the job done</li>
        <br/>

        </ul>
        No to-the-moon-and-back claims in this neck of the woods.
        <br/><br/>
        We're just solving real problems for real people here. 
        </div>
    </>
  )
}
